export const GET_USER_DATA = 'lk/user-data'
export const CREATE_SBP_SUBSCRIPTION = 'lk/payment-methods/create-sbp'
export const CHANGE_STATUS_SUBSCRIPTION = 'lk/payment-methods/change-status-subscription'
